import React from 'react';
import PropTypes from 'prop-types';

export default function ModalFooter({ children, bgColor = 'white' }) {
	return (
		<div className={`modal-footer ${bgColor}`}>
			{children}
		</div>
	);
}

ModalFooter.propTypes = {
	children: PropTypes.node,
	bgColor: PropTypes.oneOf(['white', 'navyBlue'])
};
